<template>
	<c-dialog ref="editMemberProductClassify" title="设置代理开通的爆款类目" width="400" height="600" @resolve="submit">
		<dl v-for="(classify, i) in productClassifyList" :key="i" class="classify">
			<dt><c-checkbox :checked="classify.checked" @click="checkHandle($event, classify)">{{classify.type_name}}</c-checkbox></dt>
			<dd v-if="classify.chlidren.length">
				<ul>
					<li v-for="(item, j) in classify.chlidren" :key="j"><c-checkbox :checked="item.checked" @click="checkHandle($event, item, classify)">{{item.type_name}}</c-checkbox></li>
				</ul>
			</dd>
		</dl>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				productClassifyList: []
			}
		},
		
		computed: {
			allChecked() {
				return !!this.productClassifyList.length && !this.productClassifyList.find(item => {
					return !item.checked || item.chlidren.find(item => !item.checked);
				});
			}
		},
		
		mounted() {
			
		},
		
		methods: {
			open(region_id, platform_user_id, select_product_type_list_c) {
				this.request({
					url: '/product_type/tree',
				    data:{
						region_id: region_id,
				        platform_user_id: platform_user_id
				    },
					success: data => {
						this.productClassifyList = data;
						var p_check;
						//按传入的列表设置默认选中
						this.productClassifyList.forEach(item => {
							// select_product_type_list_p.forEach(pselect => {
							// 	if(item.id == pselect.id){
							// 		this.$set(item, 'checked', true);
							// 	}
							// });
							p_check = false;
							item.chlidren.forEach(item => {
								select_product_type_list_c.forEach(cselect => {
									if(item.id == cselect.id){
										this.$set(item, 'checked', true);
										p_check = true;
									}
								});
							});
							this.$set(item, 'checked', p_check);
						});
						
					}
				});
				this.$refs.editMemberProductClassify.open();
			},

			checkHandle(state, item, classify) {
				if (item == 'all') {
					this.productClassifyList.forEach(item => {
						this.$set(item, 'checked', state);
						item.chlidren.forEach(item => {
							this.$set(item, 'checked', state);
						});
					});
				} else {
					this.$set(item, 'checked', state);
					if (classify) {
						if (state) {
							this.$set(classify, 'checked', true);
						} else if (!classify.chlidren.find(item => item.checked)) {
							this.$set(classify, 'checked', false);
						}
					} else {
						item.chlidren.forEach(item => {
							this.$set(item, 'checked', state);
						});
					}
				}
			},
			
			submit(stop, next) {
				stop();
				let select_arr = [];
				this.productClassifyList.forEach(classify => {
					classify.chlidren.forEach(item => {
						item.checked && select_arr.push(Object.assign({}, item));
					});
				});
				
				if (!select_arr.length) {
					this.$message({
						text: '请选择分类'
					});
					return;
				}
				this.$refs.editMemberProductClassify.close();
				this.$emit('resolve', select_arr);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.classify {
		padding: 0 30px;
		margin: 0px 0px;
		
		dt {
			padding: 5px 0;
		}
		
		dd {
			padding: 0 30px;
			
			li {
				padding: 1px 0;
			}
		}
	}
</style>
